import React from 'react';
import {
    Button
} from '@rebrandly/styleguide'

const LinkedinShareButton = ({ url, buttonProps = {} }) => {
    if (!url) return null;


    const shareUrl = new URL('https://linkedin.com/shareArticle');
    shareUrl.searchParams.set('url', url);

    const openShareWindow = (e) => {
        e.preventDefault();
        window.open(
            shareUrl.toString(),
            'linkedin-share',
            'width=750,height=600'
        );
    };

    return (
        <Button
            onClick={openShareWindow}
            {...buttonProps}
        >
            {buttonProps.children}
        </Button>
    );
};

export default LinkedinShareButton;